import React from 'react';
import { isUserAdminOrManager } from '../../utils/global/helper';
import useUser from '../global/useUser';
import { getInitialArtistOptions } from '../../helpers/employees';
import { getInitialFilterValue } from '../../helpers/global';

const BASE_NAME = 'requests';
const FILTER_NAMES = {
  artist: 'artist',
} as const;

const constructName = (name: keyof typeof FILTER_NAMES) =>
  `${BASE_NAME}-${FILTER_NAMES[name]}`;

function useRequestsFilters() {
  const { user } = useUser();

  const artistOptions = React.useMemo(() => {
    if (!user) return [];
    return getInitialArtistOptions(user, {
      includeFirstAvailable: true,
      includeUnassigned: true,
    });
  }, [user]);

  const [artistFilter, setArtistFilter] = React.useState<string[]>(
    getInitialFilterValue(constructName('artist'), artistOptions, 'MULTI'),
  );

  const isArtistFilterEnabled =
    user?.business?.type === 'STUDIO' && isUserAdminOrManager(user);

  return {
    artist: {
      name: constructName('artist'),
      options: artistOptions,
      state: artistFilter,
      setState: setArtistFilter,
      emptyLabel: 'Select an artist',
      allLabel: 'All artists',
      isVisible: isArtistFilterEnabled,
    },
  };
}

export default useRequestsFilters;
